import {
  DatabaseInvalidationChannel,
  type DatabaseInvalidationChannelOptions,
} from "./broadcast-channel";
import { DexieAnnotationRepository } from "./annotation-repository";
import {
  createMarginaliaDatabase,
  type CreateDatabaseOptions,
} from "./database";
import { DexieDocumentRepository } from "./document-repository";
import { DexiePageTextCacheRepository } from "./page-text-cache-repository";
import { DexiePdfBlobRepository } from "./pdf-blob-repository";
import { DexieReadingStateRepository } from "./reading-state-repository";
import { DexieSettingsRepository } from "./settings-repository";
import { LocalDataService } from "./transaction-service";

export * from "./annotation-repository";
export * from "./broadcast-channel";
export * from "./database";
export * from "./document-repository";
export * from "./migrations";
export * from "./page-text-cache-repository";
export * from "./pdf-blob-repository";
export * from "./reading-state-repository";
export * from "./schema-v1";
export * from "./settings-repository";
export * from "./storage-errors";
export * from "./storage-monitor";
export * from "./transaction-service";

export type CreateLocalDataServicesOptions = CreateDatabaseOptions & {
  broadcast?: DatabaseInvalidationChannelOptions | false;
};

export function createLocalDataServices(
  options: CreateLocalDataServicesOptions = {},
) {
  const db = createMarginaliaDatabase({ name: options.name });
  const invalidation =
    options.broadcast === false
      ? undefined
      : new DatabaseInvalidationChannel(options.broadcast);

  return {
    db,
    invalidation,
    documents: new DexieDocumentRepository(db, invalidation),
    annotations: new DexieAnnotationRepository(db, invalidation),
    pdfBlobs: new DexiePdfBlobRepository(db, invalidation),
    readingStates: new DexieReadingStateRepository(db, invalidation),
    settings: new DexieSettingsRepository(db),
    pageTextCache: new DexiePageTextCacheRepository(db),
    localData: new LocalDataService(db, invalidation),
  };
}
